import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Clique no botão abaixo para rever e confirmar as suas informações de pagamento.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Trabalhamos com Stripe para processar pagamentos. O Stripe é a plataforma de pagamento mais segura utilizada pelas maiores empresas do mundo.',
      form: {
        terms_acceptance: {
          label:
            'Ao prosseguir, aceita o nosso <FoodAmigosTerms>Acordo de Serviços</FoodAmigosTerms> e o <StripeTerms>Acordo de Conta Conectada Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'A Stripe ainda precisa dos dados abaixo ou não conseguiu verificá-los:',
        errors: 'Erros',
        awaiting_verification: 'A sua conta Stripe está a ser verificada',
        awaiting_verification_description:
          'Aguardamos que o Stripe conclua a verificação do seu negócio. Pode rever o seu perfil entretanto.',
        details_hint:
          'A Stripe verifica nomes, moradas e números de telefone em registos oficiais. Se algum estiver errado, corrija-o em Os meus dados → Informação Pessoal e a Stripe voltará a verificá-lo. Tudo o resto que a Stripe pedir pode ser adicionado no seu perfil Stripe.',
        requirements_hint:
          'Alguns destes são documentos, como o seu documento de identificação: carregue-os no passo anterior, {{step}}, e depois volte aqui.',
        requirements_hint_profile:
          'Alguns destes são documentos, como o seu documento de identificação: carregue-os no seu perfil Stripe.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Titular',
          representative: 'Representante',
          business: 'Empresa',
        },
        details: {
          first_name: 'Nome próprio',
          last_name: 'Apelido',
          email: 'Email',
          phone: 'Número de telefone',
          dob: 'Data de nascimento',
          id_number: 'Número de identificação',
          nationality: 'Nacionalidade',
          address: 'Rua e número da porta',
          city: 'Cidade',
          postal_code: 'Código postal',
          state: 'Distrito',
          country: 'País',
          id_document: 'Documento de identificação',
          proof_of_address: 'Comprovativo de morada',
          job_title: 'Cargo',
          business_name: 'Nome legal da empresa',
          tax_id: 'Número de contribuinte',
          vat_id: 'NIF/IVA',
          registration_number: 'Número de registo',
          website: 'Website',
          industry: 'Setor',
          product_description: 'Descrição do que vende',
          support_phone: 'Número de telefone do apoio ao cliente',
          owners: 'Confirmação dos titulares',
          directors: 'Confirmação dos administradores',
          executives: 'Confirmação dos executivos',
          registration_document: 'Documento de registo da empresa',
          bank_account: 'Conta bancária para pagamentos',
          business_type: 'Tipo de empresa',
          terms: 'Aceitação dos termos da Stripe',
          bank_account_proof: 'Comprovativo de titularidade da conta bancária',
          tax_id_document: 'Documento do número de contribuinte',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Trabalhamos com a Adyen para processar pagamentos. A Adyen é uma das plataformas de pagamento mais seguras, utilizada pelas maiores empresas do mundo.',
    },
  },
  labels: {
    verified: 'A sua conta {{paymentGateway}} está verificada',
    verified_description: 'A verificação do {{paymentGateway}} está concluída. Pode gerir o seu perfil se necessário.',
  },
  buttons: {
    proceed: 'Confirmar os meus dados de pagamento',
    copy_link: 'Copiar link',
    back: 'Voltar',
  },
  toasts: {
    something_went_wrong: 'Ocorreu um erro, contacte o suporte técnico',
  },
};
